import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';
import FormTextArea from './../inputs/textarea';

import FormSelect from './../inputs/select';
import FormDate from './../inputs/date';

import FormSwitch from './../inputs/switch';
import FormFileUpload from "./../inputs/fileupload";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { prepareForm, getPackageTypes } from './../../utils';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import moment from 'moment';
import FormAutoComplete from './../inputs/autocomplete';

const ExpensesWithCostsEdit = () => {

    let navigate = useNavigate();
    const { packageExpenseStore, utilsStore, companiesStore, expenseWithCostsStore } = useStores();
    const { getById, expenseWithCosts, save, reset } = expenseWithCostsStore;
    const { getCurrencies, currencies } = utilsStore;
    const { searchCompany } = companiesStore;

    const { t, i18n } = useTranslation();

    const { id } = useParams();
    const isNew = () => id && id == "new";

    const [isLoading, setIsLoading] = useState(false);
    const [validated, setValidated] = useState(false);

    useEffect(() => {
        async function fetchMyAPI() {
            setIsLoading(true);
            Promise.all([getById(id),getCurrencies()]).then(() => {
                setIsLoading(false);

            });
        }

        if (id == "new") {
            handleReset();
            getCurrencies();
        } else {
            fetchMyAPI();
        }

    }, [getById, reset]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            var formData = prepareForm(event, isNew(), ["id","companyId"]);            
            save(formData, () => { goToList() });
        }

        setValidated(true);
    };

    const handleReset = () => {
        reset();
        setValidated(false);
    };

    const goToList = () => {
        navigate("/administration/expenses-with-costs")
    };
    
    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Card>
                <Card.Body>
                    <Stack direction="vertical">
                        <Row>
                            <Col style={{ alignSelf: "center" }}  >
                                <ArrowBackIosIcon sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => goToList()} size="small" />
                                <b>{t(isNew() ? 'newExpenseWithCosts' : 'expenseWithCosts')}  {!isNew() && `(Id: ${id})`}</b>
                            </Col>
                            <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>

                            <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                        </Row>

                        <hr />

                        <Row className="my-2">
                            <Col xs={2}>
                                <FormText hidden isNumber id="id" type="number" object={expenseWithCosts} />                                
                                <FormText required label={t("nameEN")} id="nameEN" isLoading={isLoading} object={expenseWithCosts} />                                
                            </Col>


                            <Col xs={2}>
                                <FormText required label={t("nameFR")} id="nameFR" isLoading={isLoading} object={expenseWithCosts} />                                                                
                            </Col>
                        </Row>


                        <Row className="my-2">

                            <Col xs={2}>
                                <FormAutoComplete onCreateClick={() => window.open('/administration/companies/new', '_blank')} itemFn={(option) => `${option.name} - (ID: ${option.id})`} service={searchCompany} validated={validated} required label={t("company")} id="company" formId="companyId" isLoading={isLoading} object={expenseWithCosts} />
                            </Col>

                            <Col xs={2}>
                                <FormText required label={t("winbizGL")} id="winbizGL" isLoading={isLoading} object={expenseWithCosts} />
                            </Col>
                        </Row>

                    </Stack>



                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(ExpensesWithCostsEdit);
